import { Anleggskart } from '../components/Anleggskart'
import { PageHead } from '../components/Shell'
import { Link } from '../router'
import { useT } from '../lang'

/* Setting a farm up: which rings it has, and where they float.
 *
 * Staff side, and reached from the company page rather than from NAV — the
 * same place and the same reasoning as everything else in Operators.tsx. This
 * happens once per farm, at onboarding, at a desk, while somebody is on the
 * phone describing their array.
 *
 * It replaces half of scripts/mkpens.sh rather than all of it. The script is
 * still the right tool for "this farm has eight rings numbered 1 to 8"; it is
 * a hopeless tool for saying where they are, because positions are read off a
 * picture and never dictated.
 */
export function Oppsett({ id }: { id: string }) {
  const t = useT()
  // Reached from the Lusedagbok's ring step: a way back to it, which the
  // book is printed from once the drawing is saved.
  const fraBok = new URLSearchParams(window.location.search).get('fra') === 'lusedagbok'
  return (
    <>
      {fraBok && (
        <Link className="btn ghost sm" style={{ marginBottom: 12 }}
          to={`/sites/${encodeURIComponent(id)}/lusedagbok?steg=merdene`}>
          ‹ Tilbake til Lusedagboka
        </Link>
      )}
      <PageHead
        title={t('Where the pens are')}
        lead={t('Nobody knows a latitude. They know it is the one at the mouth, second from the barge.')}
      />
      <div className="card">
        <Anleggskart siteId={id} />
      </div>
    </>
  )
}
